import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { rgba } from 'polished';
import styled from 'styled-components';
const Wrapper = styled.div `
  display: block;
  user-select: none;
  margin-top: 40px;

  ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    place-content: center;
    place-items: center;
    column-gap: 10px;
    width: 100%;

    @media ${from(Device.TabletSmall)} {
      column-gap: 20px;
    }

    li {
      display: inline-block;
      opacity: 1;
      transition: opacity 0.15s ease-out;
      padding: 0;

      a {
        ${fonts.agBook.bold};
        font-size: 16px;
        line-height: 1;
        display: flex;
        color: ${brand.grey.grey41};
        background-color: ${rgba(brand.white, 0)};
        border: 2px solid ${brand.grey.grey41};
        font-feature-settings: 'tnum' on;
        margin: 0;
        place-content: center;
        place-items: center;
        text-decoration: none;
        width: 42px;
        height: 42px;

        @media ${from(Device.TabletSmall)} {
          width: 57px;
        }
      }

      a {
        ${transition('color, background-color, opacity')};
        cursor: pointer;
        position: relative;

        &:focus {
          outline: none;
          opacity: 0.6;
        }

        @supports selector(:focus-visible) {
          &:focus-visible {
            color: ${brand.black};
          }
        }

        @supports not selector(:focus-visible) {
          &:focus {
            color: ${brand.black};
          }
        }
      }

      &:not(.previous):not(.next) {
        &:hover {
          opacity: 0.6;
        }
      }

      &.previous,
      &.next {
        &:focus {
          opacity: 0.6;
        }

        a {
          width: auto;
          height: auto;
          border: none;
          background-color: transparent;
          color: ${brand.grey.grey41};

          > div {
            display: inline-flex;
            align-items: center;

            > span {
              display: none;

              @media ${from(Device.TabletSmall)} {
                display: inline-block;
              }
            }
          }

          &:focus,
          &:hover {
            svg path {
              stroke-width: 5;
            }
          }
        }

        svg {
          display: block;
          height: 26px;
          height: 26px;

          path {
            ${transition('stroke-width')};

            &:first-child {
              stroke: ${brand.grey.grey41};
            }
          }
        }
      }

      &.previous {
        svg {
          transform: scaleX(-1);

          @media ${from(Device.TabletSmall)} {
            margin-right: 10px;
          }
        }
      }

      &.next {
        svg {
          @media ${from(Device.TabletSmall)} {
            margin-left: 10px;
          }
        }
      }

      &.break {
        a {
          border: none;
          width: 30px;
          height: auto;
          font-size: 32px;
          line-height: 12px;
          top: -8px;
        }
      }

      &.selected {
        a {
          color: ${brand.white};
          background-color: ${brand.grey.grey41};
          ${transition('opacity')};

          &::after {
            opacity: 1;
          }

          @supports selector(:focus-visible) {
            &:focus-visible {
              background-color: ${brand.grey.grey13};
              color: ${brand.white};
            }
          }

          @supports not selector(:focus-visible) {
            &:focus {
              background-color: ${brand.grey.grey13};
              color: ${brand.white};
            }
          }
        }
      }

      &.disabled {
        cursor: default;
        pointer-events: none;
        display: none;
      }
    }
  }
`;
export default {
    Wrapper,
};
